































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import { Store } from 'vuex';
import PageHeader from '../../components/vui-luma/Ui/PageHeader.vue';
import PageSeparator from '../../components/vui-luma/Ui/PageSeparator.vue';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';
import {FmvInputGroupMerge} from 'fmv-input-group-merge';
import {readCategories, readStatuses} from '@/store/contacts/getters';
import {
  dispatchCreateCategory, dispatchDeleteCategory,
  dispatchGetCategories, dispatchGetContacts,
  dispatchGetStatuses,
  dispatchUpdateCategory,
} from '@/store/contacts/actions';
import {IContactsCategoryCreate} from '@/interfaces';

@Component({
  components: {
    PageHeader,
    PageSeparator,
    MdIcon,
    FmvInputGroupMerge,
  },
})
export default class StatusesCategories extends Vue {
  public statusVisible = false;
  public categoryVisible = false;
  public addCategoryVisible = false;
  public addCategoryName = '';
  public editCategoryVisible = false;
  public editCategoryName = '';
  public editCategoryId = '';

  public statusId = 0;
  public categoryId = 0;
  public searchText = '';


  public async created() {
    await dispatchGetStatuses(this.$store);
    await dispatchGetCategories(this.$store);
    const statuses = readStatuses(this.$store);
    const categories = readCategories(this.$store);
  }

  get statuses() {
    return readStatuses(this.$store);
  }

  get categories() {
    return readCategories(this.$store);
  }

  public handleCategoryEdit(category) {
    this.editCategoryName = category.title;
    this.editCategoryId = category.id;
    // @ts-ignore
    this.$refs.editCategoryModal.show();
  }

  public resetCategory() {
    this.addCategoryName = '';
    this.editCategoryName = '';
    this.editCategoryId = '';
  }

  public async submitCategory() {
    if (this.addCategoryName !== '') {
      const createdCategory: IContactsCategoryCreate = {
        title: this.addCategoryName,
      };
      await dispatchCreateCategory(this.$store, createdCategory);
      this.addCategoryVisible = false;
    }
    this.resetCategory();
  }

  public async submitCategoryEdit() {
    if (this.editCategoryName !== '' && this.editCategoryId !== '') {
      const createdCategory: IContactsCategoryCreate = {
        id: this.editCategoryId,
        title: this.editCategoryName,
      };
      await dispatchUpdateCategory(this.$store, { id: this.editCategoryId, category: createdCategory});
      this.editCategoryVisible = false;
    }
    this.resetCategory();
  }

  public async categoryDelete(categoryId) {
    await dispatchDeleteCategory(this.$store, { id: categoryId});
  }

  public isCategoryActive(id) {
    return this.categoryId === id;
  }

  public isStatusActive(id) {
    return this.statusId === id;
  }

  public async handleStatusRedirect(id) {
    if (this.statusId !== id) {
      this.statusId = id;
      await this.handleReload();
    }
  }

  public async handleCategoryRedirect(id) {
    if (this.categoryId !== id) {
      this.categoryId = id;
      await this.handleReload();
    }
  }

  public async handleReload() {
    await dispatchGetContacts(this.$store,
        {searchText: this.searchText, statusId: this.statusId, categoryId: this.categoryId});
  }

  public handleAddModal() {
    this.$parent.$data.contact = null;
  }
}
